// SPA mode: render the whole app on the client. With SSR off, universal `load`
// functions run only in the browser, so cookie-based auth guards can read
// `document.cookie` directly. Nothing prerenders by default; the adapter-static
// `index.html` fallback serves every route.
export const ssr = false;
